import React from "react";

class CopyButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      copied: false
    };
    this.reset_timer = null;
    this.copy = this.copy.bind(this);
  }

  componentWillUnmount(){
    if (this.reset_timer){
      window.clearTimeout(this.reset_timer);
    }
  }

  fallback_copy(value){
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();

    let copied = false;
    try {
      copied = document.execCommand("copy");
    } catch (error) {
      copied = false;
    } finally {
      document.body.removeChild(textarea);
    }
    return copied;
  }

  show_copied(){
    if (this.reset_timer){
      window.clearTimeout(this.reset_timer);
    }
    this.setState({copied: true});
    this.reset_timer = window.setTimeout(() => {
      this.setState({copied: false});
      this.reset_timer = null;
    }, 2000);
  }

  copy(){
    const value = String(this.props.value ?? "");
    if (navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(value).then(() => this.show_copied()).catch(() => {
        if (this.fallback_copy(value)){
          this.show_copied();
        }
      });
      return null;
    }
    if (this.fallback_copy(value)){
      this.show_copied();
    }
    return null;
  }

  render(){
    return (
      <button
        type="button"
        className={this.props.overrideClassName || "psintegril-btn psintegril-btn-secondary"}
        onClick={this.copy}
      >
        {this.state.copied ? "Copied!" : "Copy"}
      </button>
    );
  }
}

export default CopyButton;
